import React from 'react';
import PropTypes from 'prop-types';

/**
 * Riga dell'header di una `Table`.
 */
const HeaderRow = ({ children }) => (
  <tr>
    {children}
  </tr>
);

HeaderRow.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

HeaderRow.defaultProps = {
  children: null,
};

export default HeaderRow;
